import React from 'react';
import './App.css';
import APIKeyGenerator from './components/ApikeyGenerator';

function App() {
  return <APIKeyGenerator />;
}

export default App;